import React from 'react';
import WName, {WArticle} from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual, TLDR, pronouns_reason} from '../common';

export const gippetian = {
  name: "gippetian",
  prelude: <span>
    What would <i>stagsiff</i> say?
  </span>,
  question: <span>What is the ‘Gippetian’ pronoun system?</span>,
  answerPreview: <div className="answer-preview">
    <p>Frankly, it’s a reflection of the arbitrariness of 2020’s <i><QL>humanity</QL></i> – and how the <PL>human sttandard</PL> (we all, unless <i>actually thinking</i>) take things like <AL name="handicap">biological bodies</AL> super <i>seriously</i>, when <LRL>Earth</LRL> biology is just one thing that we must <NW>overcome</NW>.</p> 
    {pronouns_reason}
  </div>,
  answer: <div className="answer-text">
    <p>Just 'thrown together'; Maybe it will get actually-made later</p>
    <p>The ‘Gippetian’system (so named because <QL>Gippity</QL> <i>cannot</i> tell a <OML>story</OML> using it, even if <QL name="super-racist">mit</QL> ‘thinks‘Gippetian’/<LRL name="r">reactively</LRL> <i><PL name="form">acts like</PL></i> mit can) is based not on the presence or abscence of a penis in <NW>khets</NW> but on their <i>positionality</i>, as follows:</p>
    <ul>
      <li>For standing <NW>khets</NW>: ‘stag’.</li>
      <li>For seated <NW>khets</NW>: ‘siff’.</li>
    </ul>
    <p>Then you combine the positionality of the referent (the Person<sup>™</sup> you are talking about; <PL>you are your body</PL>) with the position of the speaker (as BODY; <PL>you are your body</PL>), if different; the ‘<PL name="individuality">self</PL>’ always goes SECOND: politeness.</p>
    <p>And mark the possessive case with the particle ናይ (‘nay’, pronounced like the <PL>English</PL> ‘nigh’), from the <QL name="languages">Tigrinya language</QL>. Because the ‘class’ devising the ‘Gippetian’ system was in Somalia (Mogadishu), but the 宝船 (bǎochuán: <PL anme="ch.">Zheng</PL>’s ‘treasure ship’) was off the coast of Eritrea. And assuming the (Eejit<sup>®</sup>) Author<sup>™</sup> was <QL name="racism">White</QL>, how many White people – but as a ‘dare’: to ShowOff<sup>®</sup> their Own<sup>™</sup> Bravery<sup>®</sup> – actually <i>want</i> to go to Eritrea OR Somalis (or, let’s be real, even know where those <NW>nation-states</NW> <i>are</i>)?</p>
  </div>,
};

